/** --------Airtable-------- */
/**
 * API request headers for Airtable integration
 *
 * @remarks
 * Defines standard headers for Authorization using a Personal Access Token
 */
export const AIRTABLE_HEADERS = {
  Authorization: `Bearer ${process.env.AIRTABLE_PERSONAL_ACCESS_TOKEN}`,
};

/**
 * Airtable ID for with `Prototypes | Viewing Experience Design` Base
 */
const AIRTABLE_BASE_ID = `apptNjDK1w6gxQP79`;

/**
 * URL for Airtable API
 */
export const AIRTABLE_URL = `https://api.airtable.com/v0/${AIRTABLE_BASE_ID}/`;

/** --------ATOM-------- */
/**
 * API request headers for Peacock platform integration
 *
 * @remarks
 * Defines standard headers that identify the client device, platform,
 * proposition, provider, and territory for all API requests
 */
export const ATOM_HEADERS = {
  /** Identifies the device type as a computer */
  "X-SkyOTT-Device": "COMPUTER",

  /** Specifies the platform as PC */
  "X-SkyOTT-Platform": "PC",

  /** Identifies the proposition as NBCU OTT */
  "X-SkyOTT-Proposition": "NBCUOTT",

  /** Specifies the provider as NBCU */
  "X-SkyOTT-Provider": "NBCU",

  /** Sets the territory to US */
  "X-SkyOTT-Territory": "US",
};

/**
 * Proxy server URL for API requests
 *
 * @remarks
 * Used to bypass CORS restrictions in development environments
 */
const PROXY_URL = "https://proxy.peacock-design-engineering.workers.dev/?";

/**
 * Base URL for the Peacock CMS API (Atom)
 *
 * @remarks
 * Base endpoint for all Atom CMS queries, routed through the proxy
 */
const ATOM_CMS_BASE_URL = `${PROXY_URL}https://atom.peacocktv.com/adapter-calypso/v3/query`;

/**
 * Atom API endpoint for fetching content by slug
 *
 * @remarks
 * Constructs the complete URL for the Atom API's node query endpoint,
 * using slug and routed through the proxy
 */
const ATOM_SLUG_URL = `${ATOM_CMS_BASE_URL}/node?&features=upcoming&slug=`;

/**
 * Atom API endpoint for fetching content by node ID
 *
 * @remarks
 * Constructs the complete URL for the Atom API's node-based query endpoint.
 * This endpoint accepts:
 * - Node IDs in UUID v4 format (e.g., "f9339b60-0707-11ef-a279-a7afc301dae7")
 * - Provider paths (e.g., "provider_series_id/12345")
 *
 * Can be used with the `represent` parameter to expand relationships (e.g., items collection).
 * Returns a single object containing the node's full details.
 */
const ATOM_NODE_URL = `${ATOM_CMS_BASE_URL}/node/`;

/**
 * URL for Peacock labels API
 */
const LABELS_URL = `${PROXY_URL}https://atom.peacocktv.com/adapter-calypso/v3/labels`;

/**
 * Base URL for Atom API
 *
 * @remarks
 * Used for constructing dynamic endpoint URLs, particularly for fetching
 * child items of groups and collections
 */
const ATOM_BASE_URL = `${PROXY_URL}https://atom.peacocktv.com`;

export {
  PROXY_URL,
  ATOM_CMS_BASE_URL,
  ATOM_SLUG_URL,
  ATOM_NODE_URL,
  ATOM_BASE_URL,
  LABELS_URL,
};
